import { useNavigate } from "react-router-dom";
import { Subtree, useSubtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { DEFAULT_ROUTE } from "../../core/primitives/routes";
import { ShellActions } from "../../shell/shell-model";
import { OnboardingPaymentsController } from "./onboarding-payments-controller";
import { OnboardingPaymentsPage } from "./onboarding-payments-page";

export function OnboardingPaymentsRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  const shell = useSubtree(ShellActions);
  return (
    <Subtree
      key="onboarding-payments"
      controller={() =>
        new OnboardingPaymentsController(
          pick(deps, "client", "authHandler", "storeRepository", "providersRepository"),
          {
            openExternal: (url) => window.location.assign(url),
            toDashboard: (storeId) => {
              shell.onboardingAnswered();
              navigate(storeId ? `${DEFAULT_ROUTE}?storeId=${encodeURIComponent(storeId)}` : DEFAULT_ROUTE, {
                replace: true,
              });
            },
          },
        )
      }
    >
      <OnboardingPaymentsPage />
    </Subtree>
  );
}
